import { render, staticRenderFns } from "./gallery-controller.vue?vue&type=template&id=2ffa9376&scoped=true&"
import script from "./gallery-controller.vue?vue&type=script&lang=js&"
export * from "./gallery-controller.vue?vue&type=script&lang=js&"
import style0 from "./gallery-controller.vue?vue&type=style&index=0&id=2ffa9376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa9376",
  null
  
)

export default component.exports